/**
 * 학교별 큰 배지(504px). 완료 화면(168px)·그룹 헤더(52px)처럼 목록용 로고(120px)
 * 보다 크거나 선명해야 하는 자리에서 쓴다. 없는 학교는 서버의 logoPath 로 물러난다.
 */
export const UNIVERSITY_BADGE: Record<string, string> = {
  sogang: '/images/university/badge-sogang.png',
  yonsei: '/images/university/badge-yonsei.png',
  ewha: '/images/university/badge-ewha.png',
}

/** '서강대학교' → '서강대', '이화여자대학교' → '이화여대' */
export const shortUniversityName = (name: string): string =>
  name.replace(/여자대학교$/, '여대').replace(/대학교$/, '대')

// 받는 사람은 앱이 없을 수 있다 — 스토어로 갈라 주는 안내 페이지로 보낸다.
const INVITE_URL = 'https://app.tastee.kr/download.html'

/**
 * 학교 친구 초대 — 휴대폰 공유창, 없으면 링크 복사.
 *
 * TODO(추천 코드): 추천 코드 화면(Figma U7)이 생기면 그 화면으로 보낸다.
 * 지금은 앱 받는 링크를 공유한다. 완료 화면과 그룹 화면이 같이 쓴다.
 */
export const inviteUniversityFriends = async (
  universityName: string,
  notify: { success: (m: string) => void; error: (m: string) => void }
): Promise<void> => {
  const text = `${shortUniversityName(universityName)} 친구들이 다녀온 맛집, TASTEE에서 같이 봐요`
  if (navigator.share) {
    try {
      await navigator.share({ title: 'TASTEE', text, url: INVITE_URL })
    } catch {
      /* 사용자가 닫음 */
    }
    return
  }
  try {
    await navigator.clipboard.writeText(`${text} ${INVITE_URL}`)
    notify.success('링크가 복사되었습니다')
  } catch {
    notify.error('공유에 실패했습니다')
  }
}
